import React, { useEffect, useMemo, useState } from 'react';
import moment from 'moment';
import ReactTable from 'react-table';
import InputMask from 'react-input-mask';
import axios from 'axios';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from 'reactstrap';
import { Configurations } from '../../../Utils/Configurations';
import ModalBeneficiariosCile from '../../../Components/Modal-Beneficiarios-Cile/Modal-Beneficiarios-Cile';
import '../Products/Products.scss';
import ErrorModal from '../../../Components/ErrorModal/ErrorModal';
import Select from 'react-select';
import makeAnimated from 'react-select/lib/animated';

const exibeValor = (valor) => {
    if (valor === undefined || valor === null || valor === '') return '-';
    return valor;
};

const formatCurrency = (value) => {
    if (!value) return 'R$ 0,00';

    return Number(value).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    });
};

const SubscriptionCileDetails = (props) => {
    const idAssinatura = props.match.params.idAssinatura;
    const config = new Configurations();

    const [detalhesAssinatura, setDetalhesAssinatura] = useState({});
    const [loading, setLoading] = useState(true);
    const [modalEndereco, setModalEndereco] = useState(false);
    const [modalEnderecoPedido, setModalEnderecoPedido] = useState(false);
    const [enderecoPedido, setEnderecoPedido] = useState({});
    const [loadingEnderecoPedido, setLoadingEnderecoPedido] = useState(false);
    const [exibeDestinatarioPedido, setExibeDestinatarioPedido] = useState(false);
    const [modalTransportadora, setModalTransportadora] = useState(false);
    const [modalPagamento, setModalPagamento] = useState(false);
    const [modalPixBoleto, setModalPixBoleto] = useState(false);
    const [modalOrganizacao, setModalOrganizacao] = useState(false);
    const [modalDestinatario, setModalDestinatario] = useState(false);
    const [modalBeneficiariosCile, setModalBeneficiariosCile] = useState(false);
    const [copiado, setCopiado] = useState(false);
    const [listaBeneficiariosCile, setListaBeneficiariosCile] = useState([]);
    const [infosPedido, setInfosPedido] = useState({});
    const [enderecoForm, setEnderecoForm] = useState({
        nome: '',
        cep: '',
        logradouro: '',
        bairro: '',
        cidade: '',
        uf: '',
        numero: '',
        complemento: '',
        semNumero: false,
    });
    const [cepConsultado, setCepConsultado] = useState('');
    const [isLoadingPedidos, setIsLoadingPedidos] = useState(true);
    const [listaPedidos, setListaPedidos] = useState([]);
    const [paginaPedidos, setPaginaPedidos] = useState(0);
    const [limitePedidos, setLimitePedidos] = useState(5);
    const [totalPaginasPedidos, setTotalPaginasPedidos] = useState(0);
    const [isLoadingHistorico, setIsLoadingHistorico] = useState(true);
    const [historicoAssinatura, setHistoricoAssinatura] = useState([]);
    const [listaEnderecos, setListaEnderecos] = useState([]);
    const [novoEndereco, setNovoEndereco] = useState()
    const [loadingEndereco, setLoadingEndereco] = useState(false);
    const [modoNovoEndereco, setModoNovoEndereco] = useState(false);
    const [loadingSelecionarEndereco, setLoadingSelecionarEndereco] = useState(false);
    const [modalStatus, setModalStatus] = useState(false);
    const [statusSelecionado, setStatusSelecionado] = useState(null);
    const [loadingSalvarStatus, setLoadingSalvarStatus] = useState(false);
    const [transportadoraSelecionada, setTransportadoraSelecionada] = useState(null);
    const [loadingSalvarTransportadora, setLoadingSalvarTransportadora] = useState(false);
    const [pagamentoSelecionado, setPagamentoSelecionado] = useState(null);
    const [loadingSalvarPagamento, setLoadingSalvarPagamento] = useState(false);
    const [loadingSalvarDestinatario, setLoadingSalvarDestinatario] = useState(false);
    const [modalSuccess, setModalSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [hasError, setHasError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [nomeDestinatario, setNomeDestinatario] = useState('');
    const [showCupom, setShowCupom] = useState(false);

    const animatedComponents = useMemo(() => makeAnimated(), []);

    const chamadaDetalhesAssinatura = () => {
        setLoading(true);

        const config = new Configurations();

        axios.get(config.apiBasePath + `/assinaturas-cile/detalhes/${idAssinatura}`)
            .then(response => {

                setDetalhesAssinatura(response.data.data);
                setEnderecoForm({
                    nome: response.data.data.endereco.nome || '',
                    cep: response.data.data.endereco.cep || '',
                    logradouro: response.data.data.endereco.logradouro || '',
                    bairro: response.data.data.endereco.bairro || '',
                    cidade: response.data.data.endereco.cidade || '',
                    uf: response.data.data.endereco.uf || '',
                    numero: response.data.data.endereco.numero || '',
                    complemento: response.data.data.endereco.complemento || '',
                    semNumero: false,
                });
                setCepConsultado((response.data.data.endereco.cep || '').replace(/\D/g, ''));
            })
            .catch(err => {
                console.log("ERROR: ", err);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const chamadaPedidos = () => {
        setIsLoadingPedidos(true);

        const config = new Configurations();

        axios.get(config.apiBasePath + `/assinaturas-cile/detalhes/${idAssinatura}/pedidos?pagina=1&limite=10`)
            .then(response => {
                setListaPedidos(response.data.data);
                setTotalPaginasPedidos(Math.ceil(response.data.pagination.total / limitePedidos));
            })
            .catch(err => {
                console.log("ERROR: ", err);
            })
            .finally(() => {
                setIsLoadingPedidos(false);
            });
    };

    const chamadaHistorico = () => {
        setIsLoadingHistorico(true);

        const config = new Configurations();

        axios.get(config.apiBasePath + `/assinaturas-cile/detalhes/${idAssinatura}/historico`)
            .then(response => {
                setHistoricoAssinatura(response.data.data);
            })
            .catch(err => {
                console.log("ERROR: ", err);
            })
            .finally(() => {
                setIsLoadingHistorico(false);
            });
    };

    useEffect(() => {
        chamadaDetalhesAssinatura();
    }, [idAssinatura]);

    useEffect(() => {
        chamadaPedidos();
        chamadaHistorico();
    }, []);

    useEffect(() => {
        if (!modalEndereco) {
            return;
        }

        const cepLimpo = (enderecoForm.cep || '').replace(/\D/g, '');
        if (cepLimpo.length !== 8 || cepLimpo === cepConsultado) {
            return;
        }

        setCepConsultado(cepLimpo);
        axios.get(config.apiBasePath + `/cep/${cepLimpo}`)
            .then((response) => {
                const endereco = response.data.endereco || {};
                setEnderecoForm((prevState) => ({
                    ...prevState,
                    logradouro: endereco.logradouro || '',
                    bairro: endereco.bairro || '',
                    cidade: endereco.cidade || '',
                    uf: endereco.uf || '',
                }));
            })
            .catch(() => {
                setEnderecoForm((prevState) => ({
                    ...prevState,
                    logradouro: '',
                    bairro: '',
                    cidade: '',
                    uf: '',
                }));
            });
    }, [config.apiBasePath, cepConsultado, enderecoForm.cep, modalEndereco]);

    const toggleModalEndereco = () => {
        setModalEndereco(!modalEndereco);
        setNovoEndereco(null);
    }
    const toggleModalEnderecoPedido = () => setModalEnderecoPedido(!modalEnderecoPedido);
    const toggleModalTransportadora = () => setModalTransportadora(!modalTransportadora);
    const toggleModalPagamento = () => setModalPagamento(!modalPagamento);
    const toggleModalPixBoleto = () => setModalPixBoleto(!modalPixBoleto);
    const toggleModalOrganizacao = () => setModalOrganizacao(!modalOrganizacao);
    const toggleModalDestinatario = () => setModalDestinatario(!modalDestinatario);
    const toggleModalStatus = () => {
        setModalStatus(!modalStatus);
        setStatusSelecionado(null);
    };
    const toggleModalSuccess = () => setModalSuccess(!modalSuccess);
    const toggleModalBeneficiariosCile = () => {
        setModalBeneficiariosCile(!modalBeneficiariosCile);
    };
    const toggleShowCupom = () => setShowCupom(!showCupom);

    const abrirModalEndereco = () => {
        setEnderecoForm({
            nome: '',
            cep: '',
            logradouro: '',
            bairro: '',
            cidade: '',
            uf: '',
            numero: '',
            complemento: '',
            semNumero: false,
        });
        setCepConsultado('');
        setModoNovoEndereco(false);
        setLoadingSelecionarEndereco(false);
        buscarEnderecos();
        toggleModalEndereco();
    };

    const abrirNovoEndereco = () => {
        setEnderecoForm({
            nome: '',
            cep: '',
            logradouro: '',
            bairro: '',
            cidade: '',
            uf: '',
            numero: '',
            complemento: '',
            semNumero: false,
        });
        setCepConsultado('');
        setModoNovoEndereco(true);
    };

    const abrirModalTransportadora = () => {
        setTransportadoraSelecionada(resolveTransportadoraId(detalhesAssinatura.transportadora));
        toggleModalTransportadora();
    };

    const abrirModalPagamento = () => {
        setPagamentoSelecionado(resolvePagamentoId(detalhesAssinatura.pagamento));
        toggleModalPagamento();
    };

    const abrirModalDestinatario = () => {
        const enderecoAtual = detalhesAssinatura && detalhesAssinatura.endereco ? detalhesAssinatura.endereco : {};
        setNomeDestinatario(enderecoAtual.nomeDestinatario || '');
        toggleModalDestinatario();
    };

    const salvarModalEndereco = (novo) => {
        const config = new Configurations();
        const body =
            novo ?
                {
                    cep: enderecoForm.cep.replace(/\D/g, ''),
                    logradouro: enderecoForm.logradouro,
                    bairro: enderecoForm.bairro,
                    cidade: enderecoForm.cidade,
                    uf: enderecoForm.uf,
                    numero: enderecoForm.semNumero ? 'S/N' : enderecoForm.numero,
                    complemento: enderecoForm.complemento,
                    nomeEndereco: enderecoForm.nome,
                }
                :
                {
                    idEndereco: novoEndereco,
                }

        axios.put(config.apiBasePath + `/assinaturas-cile/endereco/${idAssinatura}`, body)
            .then(response => {
                setSuccessMessage(response.data && response.data.message ? response.data.message : 'Alteração realizada com sucesso');
                toggleModalSuccess();
                chamadaDetalhesAssinatura();
                chamadaHistorico();
            })
            .catch(err => {
                setErrorMessage((err.response && err.response.data && err.response.data.message) ? err.response.data.message : 'Erro ao alterar endereço');
                setHasError(true);
            })
        toggleModalEndereco();
    };

    const salvarModalTransportadora = () => {
        if (transportadoraSelecionada === null) {
            return;
        }

        setLoadingSalvarTransportadora(true);
        const config = new Configurations();

        axios.put(config.apiBasePath + `/assinaturas-cile/transportadora/${idAssinatura}`,
            { idTransportadora: transportadoraSelecionada }
        )
            .then(response => {
                setSuccessMessage(response.data && response.data.message ? response.data.message : 'Alteração realizada com sucesso');
                toggleModalTransportadora();
                setModalSuccess(true);
                chamadaDetalhesAssinatura();
                chamadaHistorico();
            })
            .catch(err => {
                setErrorMessage((err.response && err.response.data && err.response.data.message) ? err.response.data.message : 'Erro ao alterar transportadora');
                setHasError(true);
            })
            .finally(() => {
                setLoadingSalvarTransportadora(false);
            });
    };

    const salvarModalPagamento = () => {
        if (pagamentoSelecionado === null) {
            return;
        }

        setLoadingSalvarPagamento(true);
        const config = new Configurations();

        axios.put(config.apiBasePath + `/assinaturas-cile/forma-pagamento/${idAssinatura}`,
            { idTipoPagamento: pagamentoSelecionado }
        )
            .then(response => {
                setSuccessMessage(response.data && response.data.message ? response.data.message : 'Alteração realizada com sucesso');
                toggleModalPagamento();
                setModalSuccess(true);
                chamadaDetalhesAssinatura();
                chamadaHistorico();
            })
            .catch(err => {
                setErrorMessage((err.response && err.response.data && err.response.data.message) ? err.response.data.message : 'Erro ao alterar pagamento');
                setHasError(true);
            })
            .finally(() => {
                setLoadingSalvarPagamento(false);
            });
    };

    const salvarModalDestinatario = () => {
        setLoadingSalvarDestinatario(true);
        const config = new Configurations();

        axios.put(config.apiBasePath + `/assinaturas-cile/assinatura/destinatario/${idAssinatura}`,
            { nomeDestinatario: nomeDestinatario }
        )
            .then(response => {
                setSuccessMessage(response.data && response.data.message ? response.data.message : 'Alteracao realizada com sucesso');
                toggleModalDestinatario();
                setModalSuccess(true);
                chamadaDetalhesAssinatura();
                chamadaHistorico();
            })
            .catch(err => {
                setErrorMessage((err.response && err.response.data && err.response.data.message) ? err.response.data.message : 'Erro ao alterar destinatario');
                setHasError(true);
            })
            .finally(() => {
                setLoadingSalvarDestinatario(false);
            });
    };

    const alterarStatusAssinatura = () => {
        setLoadingSalvarStatus(true);
        const config = new Configurations();
        const id = props.match.params.idAssinatura;

        axios.put(config.apiBasePath + `/assinaturas-cile/status/${id}`,
            { status: statusSelecionado }
        )
            .then(response => {
                setSuccessMessage(response.data.message);
                toggleModalStatus();
                setModalSuccess(true);
                chamadaDetalhesAssinatura();
                chamadaHistorico();
            })
            .catch(err => {
                setErrorMessage((err.response && err.response.data && err.response.data.message) ? err.response.data.message : 'Erro ao alterar status');
                setHasError(true);
            })
            .finally(() => {
                setLoadingSalvarStatus(false);
            });
    };

    const buscarEnderecos = () => {
        setLoadingEndereco(true);
        const config = new Configurations();
        axios.get(config.apiBasePath + `/membros/${dados.idUsuario}/enderecos`
            // futuramente utilizar id do membro vindo da assinatura
        )
            .then(response => {
                setListaEnderecos(response.data.enderecos);
            })
            .catch(err => {
                console.log("ERROR: ", err);
            })
            .finally(() => {
                setLoadingEndereco(false);
            });
    };


    const buscarBeneficiarios = (idPedido) => {
        const config = new Configurations();
        // axios.get(config.apiBasePath + `/pedidos/${idPedido}/cile/beneficiarios`)
        axios.get(config.apiBasePath + `/assinaturas-cile/${idPedido}/beneficiarios`)
            .then((response) => {
                setListaBeneficiariosCile(response.data.listaBeneficiarios);
                setInfosPedido(response.data.infosPedido);

                toggleModalBeneficiariosCile();
            });
    };

    const buscarEnderecoPedido = (idPedido, exibeDestinatario = false) => {
        setLoadingEnderecoPedido(true);
        setEnderecoPedido({});
        setExibeDestinatarioPedido(exibeDestinatario);
        toggleModalEnderecoPedido();

        const config = new Configurations();

        axios.get(config.apiBasePath + `/enderecos/id/${idPedido}`)
            .then(response => {
                setEnderecoPedido(response.data.endereco);
            })
            .catch(err => {
                console.log("ERROR: ", err);
            })
            .finally(() => {
                setLoadingEnderecoPedido(false);
            });
    };

    const codigoPagamento = '00020101021226880014br.gov.bcb.pix2563qrcodes-pix.bcb.gov.br/v2/1234567890123456789012345204000053039865406120.505802BR5925Pagamento Exemplo6009Sao Paulo62140510CILE1234566304ABCD';

    const handleCopy = (valor) => {
        navigator.clipboard.writeText(valor);
        setCopiado(true);

        setTimeout(() => {
            setCopiado(false);
        }, 2000);
    };

    const onChangeEndereco = (e) => {
        const { name, value, type, checked } = e.target;
        setEnderecoForm((prevState) => ({
            ...prevState,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleStatusChange = (selectedOption) => {
        setStatusSelecionado(selectedOption ? selectedOption.value : null);
    };

    const handleTransportadoraChange = (selectedOption) => {
        setTransportadoraSelecionada(selectedOption ? selectedOption.value : null);
    };

    const handlePagamentoChange = (selectedOption) => {
        setPagamentoSelecionado(selectedOption ? selectedOption.value : null);
    };

    const resolvePagamentoId = (pagamentoAtual) => {
        if (!pagamentoAtual) {
            return null;
        }

        if (pagamentoAtual.idPagamento !== undefined && pagamentoAtual.idPagamento !== null) {
            return pagamentoAtual.idPagamento;
        }

        const forma = (pagamentoAtual.forma || pagamentoAtual.tipoPagamento || '').toLowerCase();
        if (forma.includes('pix')) {
            return 10;
        }
        if (forma.includes('boleto')) {
            return 2;
        }
        if (forma.includes('cartao') || forma.includes('cartão')) {
            const parcelas = Number(pagamentoAtual.parcelas);
            if (parcelas === 3) return 3;
            if (parcelas === 6) return 4;
            if (parcelas === 12) return 5;
            return 1;
        }

        return null;
    };

    const resolveTransportadoraId = (transportadoraAtual) => {
        if (!transportadoraAtual) {
            return null;
        }

        if (typeof transportadoraAtual === 'object') {
            if (transportadoraAtual.idTransportadora !== undefined && transportadoraAtual.idTransportadora !== null) {
                return transportadoraAtual.idTransportadora;
            }
            if (transportadoraAtual.id !== undefined && transportadoraAtual.id !== null) {
                return transportadoraAtual.id;
            }
            if (transportadoraAtual.nome) {
                transportadoraAtual = transportadoraAtual.nome;
            }
        }

        const nome = String(transportadoraAtual).toLowerCase();
        if (nome.includes('spdl')) return 7;
        if (nome.includes('loggi')) return 14;
        if (nome.includes('jadlog')) return 9;
        if (nome.includes('pac')) return 13;
        if (nome.includes('sedex') && nome.includes('melhor')) return 11;
        if (nome.includes('sedex')) return 12;
        if (nome.includes('correios')) return 3;

        return null;
    };

    const badgeColor = (badge) => {
        switch (badge) {
            case 'Ativa':
                return 'success';
            case 'Processando':
                return 'warning';
            case 'Inativa':
                return 'secondary';
            default:
                return 'primary';
        }
    }

    const isPlanoDigital = (detalhesAssinatura && detalhesAssinatura.plano ? detalhesAssinatura.plano : '').includes('Digital');

    const columnsPedidos = useMemo(() => {
        const columns = [
            {
                Header: 'ID Pedido',
                accessor: 'idPedido',
                className: 'text-center pointer',
                width: 110,
            },
            {
                Header: 'Valor',
                accessor: 'valor',
                className: 'text-center pointer',
                width: 120,
                Cell: row => <span>{formatCurrency(row.value)}</span>,
            },
            {
                Header: 'Data Pedido',
                accessor: 'dtPedido',
                className: 'text-center pointer',
                width: 140,
                Cell: row => (row.value ? <span>{moment(row.value).format('DD/MM/YY')}</span> : <span>-</span>),
            },
            {
                Header: 'Data Pagamento',
                accessor: 'dtPagamento',
                className: 'text-center pointer',
                width: 150,
                Cell: row => (row.value ? <span>{moment(row.value).format('DD/MM/YY')}</span> : <span>-</span>),
            },
            {
                Header: 'Status',
                accessor: 'status',
                className: 'text-center pointer',
                width: 120,
                Cell: row => (row.value ? <span className={`badge badge-${statusBadgeColor(row.value)}`}>{statusLabel(row.value)}</span> : <span>-</span>),
            },
        ];

        if (!isPlanoDigital) {
            columns.push({
                Header: 'Endereço',
                accessor: 'endereco',
                className: 'text-center pointer',
                width: 120,
                Cell: row => (<button
                    type="button"
                    className="btn btn-outline-info btn-sm"
                    onClick={() => buscarEnderecoPedido(row.original.idEndereco)}
                >
                    Endereço
                </button>
                ),
            });
        }

        if (isPlanoDigital) {
            columns.push({
                Header: 'Beneficiários',
                accessor: 'beneficiarios',
                className: 'text-center pointer',
                width: 150,
                Cell: (row) => (
                    <button
                        type="button"
                        className="btn btn-outline-info btn-sm"
                        onClick={() => buscarBeneficiarios(row.original.idPedido)}
                    >
                        Beneficiários
                    </button>
                ),
            },
                {
                    Header: 'Vigência',
                    accessor: 'vigencia',
                    className: 'text-center pointer',
                    width: 200,
                    Cell: row => (row.original.vigencia.dtInicio && row.original.vigencia.dtFim
                        ? <span>{moment(row.original.vigencia.dtInicio).format('DD/MM/YY')} - {moment(row.original.vigencia.dtFim).format('DD/MM/YY')}</span>
                        : <span>-</span>),
                }
            );
        }
        return columns;
    }, [buscarBeneficiarios, buscarEnderecoPedido, isPlanoDigital]);

    const columnsHistorico = useMemo(() => [
        {
            Header: 'Ação',
            accessor: 'acao',
            className: 'text-left',
            width: 310,
        },
        {
            Header: 'Dt. Modificação',
            accessor: 'dtModificacao',
            className: 'text-center',
            width: 160,
            Cell: row => (row.value ? <span>{moment(row.value).format('DD/MM/YYYY HH:mm')}</span> : <span>-</span>),
        },
        {
            Header: 'Usuário',
            accessor: 'usuarioModificador',
            className: 'text-center',
            width: 250,
        },
        {
            Header: 'Valor Antigo',
            accessor: 'valorAntigo',
            className: 'text-center',
            width: 180,
        },
        {
            Header: 'Novo Valor',
            accessor: 'valorNovo',
            className: 'text-center',
            width: 180,
        },
    ], []);

    const selecionaPedido = (idPedido) => {
        props.history.push({ pathname: `/pedidos/detalhes/${idPedido}` });
    };

    const onPageChangePedidos = (pageIndex) => {
        setPaginaPedidos(pageIndex);
    };

    const onPageSizeChangePedidos = (pageSize, pageIndex) => {
        setLimitePedidos(pageSize);
        setPaginaPedidos(pageIndex);
    };

    const closeErrorModal = () => {
        setHasError(false);
        setErrorMessage('');
    };

    const dados = detalhesAssinatura || {};
    const organizacao = dados.organizacao || {};
    const pagamento = dados.pagamento || {};
    const endereco = dados.endereco || {};
    const vigencia = dados.vigencia || {};
    const cupomMock = {
        idCupom: 1,
        nomeCupom: 'CUPOM10',
        valor: 10.00,
    };
    const cupom = dados.cupom || cupomMock;
    const isParcelado = pagamento.tipoPagamento === 'Cartão de crédito';
    const colPagamentoClass = isParcelado ? 'col-md-3' : 'col-md-4';
    const orderDetails = detalhesAssinatura;
    const statusOptions = [
        { label: 'Ativa', value: 1 },
        { label: 'Inativa', value: 0 },
        { label: 'Inadimplente', value: 2 },
        { label: 'Pausada', value: 3 },
    ];
    const pagamentoOptions = [
        { label: 'Pix', value: 10 },
        { label: 'Boleto Bancário', value: 2 },
        { label: 'Cartão de crédito - à vista', value: 1 },
        { label: 'Cartão de crédito - 3x', value: 3 },
        { label: 'Cartão de crédito - 6x', value: 4 },
        { label: 'Cartão de crédito - 12x', value: 5 },
    ];
    const transportadoraOptions = [
        { label: 'Correios', value: 3 },
        { label: 'SPDL', value: 7 },
        { label: 'JADLOG', value: 9 },
        { label: 'SEDEX - Melhor Envio', value: 11 },
        { label: 'SEDEX - Correios', value: 12 },
        { label: 'PAC - Melhor Envio', value: 13 },
        { label: 'Loggi', value: 14 },
    ];

    const transportadoraLabel = (id) => {
        switch (id) {
            case 3:
                return 'Correios';
            case 7:
                return 'SPDL';
            case 9:
                return 'JADLOG';
            case 10:
                return 'CARGO';
            case 11:
                return 'SEDEX - Melhor Envio';
            case 12:
                return 'SEDEX - Correios';
            case 13:
                return 'PAC - Melhor Envio';
            case 14:
                return 'Loggi';
            default:
                return '-';
        }
    }

    const statusLabel = (id) => {
        switch (id) {
            case 4:
                return 'Pago';
            case 16:
                return 'Enviado Protheus';
            case 11:
                return 'Faturado';
            case 15:
                return 'Etiqueta Gerada';
            case 13:
                return 'Enviado';
            case 14:
                return 'Entregue';
            case 2:
                return 'Cancelado';
            case 17:
                return 'Boleto Recorrência - Aguardando pagamento';
            case 18:
                return 'Recobrança manual';
            case 19:
                return 'Em transporte';
            case 22:
                return 'Auxiliar';
            case 23:
                return 'Retirar na agência';
            case 24:
                return 'Pacote criado';
            default:
                return '-';
        }
    }

    const statusBadgeColor = (id) => {
        switch (id) {
            case 2:
                return "danger";
            case 4:
                return "success";
            case 11:
                return "warning";
            case 13:
                return "info";
            case 14:
                return "primary";
            case 15:
                return "orange";
            case 16:
                return "secondary";
            case 17:
                return "danger";
            case 18:
                return "secondary";
            case 19:
                return "purple";
            case 24:
                return "lightblue";
            default:
                return "secondary";
        }
    }

    const statusSelecionadoOption = statusOptions.find((status) => status.value === statusSelecionado) || null;
    const pagamentoSelecionadoOption = pagamentoOptions.find((opcao) => opcao.value === pagamentoSelecionado) || null;
    const transportadoraSelecionadaOption = transportadoraOptions.find((opcao) => opcao.value === transportadoraSelecionada) || null;

    return (
        <div className="row edition-list">
            <div className="col-12 mb-3">
                <div className="row no-gutters align-items-center">
                    <div className="col-12 col-lg-8 text-center text-lg-left">
                        <h2 className="title-1">CILE - Detalhes da Assinatura - {props.match.params.idAssinatura}</h2>
                    </div>
                    <div className="col-12 col-lg-4 text-center text-lg-right">
                        <div className="row no-gutters">
                            <div className="col py-2 py-lg-0">
                                <button
                                    className="btn btn-outline-secondary mx-2"
                                    type="button"
                                    onClick={() => props.history.push({ pathname: '/cile/assinaturas/lista' })}
                                >
                                    Voltar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-12">
                {loading ? (
                    <div className="row">
                        <div className="col-12 py-3 text-center">
                            <div className="spinner-border text-primary" role="status" />
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="row">
                            <div className="col-12">
                                <div className="card shadow-sm mb-3">
                                    <div className="card-header">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <h6 className="mb-0">Informações Gerais</h6>
                                            <div />
                                        </div>
                                    </div>
                                    <div className="card-body pt-3">
                                        <div className="row">
                                            <div className="col-md-2 mb-3">
                                                <div className="text-muted" style={{ fontSize: '12px' }}>ID</div>
                                                <div><strong>{exibeValor(dados.id)}</strong></div>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <div className="text-muted" style={{ fontSize: '12px' }}>Plano</div>
                                                <div><strong>{exibeValor(dados.plano)}</strong></div>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <div className="text-muted" style={{ fontSize: '12px' }}>Status</div>
                                                <div className='d-flex align-items-center justify-content-between'>
                                                    <div className={`badge badge-${badgeColor(dados.status)}`}>
                                                        <strong>{exibeValor(dados.status)}</strong>
                                                    </div>
                                                    <button className="btn btn-outline-info btn-sm" type="button" onClick={toggleModalStatus}>
                                                        Alterar status
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <div className="text-muted" style={{ fontSize: '12px' }}>Início</div>
                                                <div><strong>{dados.inicio ? moment(dados.inicio).format('DD/MM/YY') : '-'}</strong></div>
                                            </div>
                                        </div>
                                        <hr />
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <div className="text-muted" style={{ fontSize: '12px' }}>Nome Solicitante</div>
                                                <div className="d-flex justify-content-between align-items-end">
                                                    <div><strong>{exibeValor(dados.nomeSolicitante)}</strong></div>
                                                    <button className="btn btn-outline-orange btn-sm" type="button" onClick={toggleModalOrganizacao}>
                                                        Organização
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <div className="text-muted" style={{ fontSize: '12px' }}>Data do último Pedido</div>
                                                <div><strong>{dados.dtPedido ? moment(dados.dtAssinatura).format('DD/MM/YY') : '-'}</strong></div>
                                            </div>
                                            {!isPlanoDigital && (
                                                <div className="col-md-3 mb-3 d-flex justify-content-between align-items-end">
                                                    <div>
                                                        <div className="text-muted" style={{ fontSize: '12px' }}>Transportadora</div>
                                                        <div><strong>{transportadoraLabel(dados.idTransportadora)}</strong></div>
                                                    </div>
                                                    <button className="btn btn-outline-info btn-sm" type="button" onClick={abrirModalTransportadora}>
                                                        Editar
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row mt-3">
                            <div className="col-12 col-lg-6">
                                <div className="card shadow-sm mb-3">
                                    <div className="card-header">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <h6 className="mb-0">Pagamento</h6>
                                            <div>
                                                <button className="btn btn-outline-info btn-sm" type="button" onClick={abrirModalPagamento}>
                                                    Editar
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body pt-3">
                                        <div className="row">
                                            <div className="col-md-4 mb-3">
                                                <div className="text-muted" style={{ fontSize: '12px' }}>Forma de Pagamento</div>
                                                <div><strong>{exibeValor(pagamento.forma)}</strong></div>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <div className="text-muted" style={{ fontSize: '12px' }}>Valor do plano</div>
                                                <div><strong style={{ fontSize: '16px' }}>{formatCurrency(pagamento.valorPlano)}</strong></div>
                                            </div>
                                            <div className={"col-md-4 mb-3"}>
                                                <div className="text-muted" style={{ fontSize: '12px' }}>Ciclo Atual</div>
                                                <div><strong>{exibeValor(pagamento.cicloAtual)}</strong></div>
                                            </div>
                                        </div>
                                        <hr />
                                        <div className="row">
                                            {isParcelado && (
                                                <div className={`${colPagamentoClass} mb-3`}>
                                                    <div className="text-muted" style={{ fontSize: '12px' }}>Parcelas</div>
                                                    <div><strong>{exibeValor(pagamento.parcelas)}</strong></div>
                                                </div>
                                            )}
                                            <div className={`${colPagamentoClass} mb-3`}>
                                                <div className="text-muted" style={{ fontSize: '12px' }}>Desconto
                                                    <svg onClick={toggleShowCupom} className='ml-1 cursor-pointer' xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                                        <path d="M0 0h24v24H0z" fill="none" />
                                                        <g fill="none">
                                                            <path d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" />
                                                            <path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2m0 2a8 8 0 1 0 0 16a8 8 0 0 0 0-16m0 12a1 1 0 1 1 0 2a1 1 0 0 1 0-2m0-9.5a3.625 3.625 0 0 1 1.348 6.99a.8.8 0 0 0-.305.201c-.044.05-.051.114-.05.18L13 14a1 1 0 0 1-1.993.117L11 14v-.25c0-1.153.93-1.845 1.604-2.116a1.626 1.626 0 1 0-2.229-1.509a1 1 0 1 1-2 0A3.625 3.625 0 0 1 12 6.5" />
                                                        </g>
                                                    </svg>

                                                </div>
                                                <div><strong>{formatCurrency(pagamento.desconto)}</strong></div>
                                            </div>
                                            {dados.plano.includes("Digital") ?
                                                null
                                                :
                                                <div className={`${colPagamentoClass} mb-3`}>
                                                    <div className="text-muted" style={{ fontSize: '12px' }}>Frete</div>
                                                    <div><strong>{formatCurrency(pagamento.frete)}</strong></div>
                                                </div>
                                            }
                                            <div className={`${colPagamentoClass} mb-3`}>
                                                <div className="text-muted" style={{ fontSize: '12px' }}>Valor total</div>
                                                <div><strong>{formatCurrency(pagamento.valorTotal)}</strong></div>
                                            </div>
                                        </div>
                                        {showCupom && (
                                            <>
                                                <hr />
                                                <div className="row align-items-end">
                                                    <div className="col-md-8 mb-3">
                                                        <div className="text-muted" style={{ fontSize: '12px' }}>Código do cupom </div>
                                                        <div><strong>{exibeValor(cupom.codigoCupom)}</strong></div>
                                                    </div>
                                                    <div className="col-md-4 mb-3">
                                                        <div className={`badge badge-${cupom.tipoCupom === 1 ? 'info' : 'purple'}`}>
                                                            <strong>{cupom.tipoCupom === 1 ? 'Promocional' : 'Crédito'}</strong>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-lg-6">
                                {dados.plano.includes("Digital") ? (
                                    <div className="card shadow-sm mb-3">
                                        <div className="card-header">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <h6 className="mb-0">Vigência</h6>
                                            </div>
                                        </div>
                                        <div className="card-body pt-3">
                                            <div className="row">
                                                <div className="col-md-4 mb-3">
                                                    <div className="text-muted" style={{ fontSize: '12px' }}>Data Início</div>
                                                    <div><strong>{vigencia.dtInicio ? moment(vigencia.dtInicio).format('DD/MM/YYYY') : '-'}</strong></div>
                                                </div>
                                                <div className="col-md-4 mb-3">
                                                    <div className="text-muted" style={{ fontSize: '12px' }}>Data Fim</div>
                                                    <div><strong>{vigencia.dtFim ? moment(vigencia.dtFim).format('DD/MM/YYYY') : '-'}</strong></div>
                                                </div>
                                                <div className="col-md-4 mb-3">
                                                    <div className="text-muted" style={{ fontSize: '12px' }}>Status</div>
                                                    <div><strong>{exibeValor(vigencia.status)}</strong></div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4 mb-3">
                                                    <div className="text-muted" style={{ fontSize: '12px' }}>Data Pagamento</div>
                                                    <div><strong>{vigencia.dtPagamento ? moment(vigencia.dtPagamento).format('DD/MM/YYYY') : '-'}</strong></div>
                                                </div>
                                                <div className="col-md-4 mb-3">
                                                    <div className="text-muted" style={{ fontSize: '12px' }}>ID Pedido</div>
                                                    <div><strong>{exibeValor(vigencia.idPedido)}</strong></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="card shadow-sm mb-3">
                                        <div className="card-header">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <h6 className="mb-0">Endereço</h6>
                                                <button className="btn btn-outline-info btn-sm" type="button" onClick={abrirModalEndereco}>
                                                    Substituir Endereço
                                                </button>
                                            </div>
                                        </div>
                                        <div className="card-body pt-3">
                                            <div className="row align-items-center">
                                                <div className="col-md-10 mb-3">
                                                    <div className="text-muted" style={{ fontSize: '12px' }}>Nome destinatário</div>
                                                    <div><strong>{exibeValor(endereco.nomeDestinatario)}</strong></div>
                                                </div>
                                                <div className="col-md-2 mb-3">
                                                    <button className='btn btn-sm btn-outline-info' type="button" onClick={abrirModalDestinatario}>Editar</button>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6 mb-3">
                                                    <div className="text-muted" style={{ fontSize: '12px' }}>Nome</div>
                                                    <div><strong>{exibeValor(endereco.nome)}</strong></div>
                                                </div>
                                                <div className="col-md-3 mb-3">
                                                    <div className="text-muted" style={{ fontSize: '12px' }}>CEP</div>
                                                    <div><strong>{exibeValor(endereco.cep)}</strong></div>
                                                </div>
                                                <div className="col-md-3 mb-3">
                                                    <div className="text-muted" style={{ fontSize: '12px' }}>UF</div>
                                                    <div><strong>{exibeValor(endereco.uf)}</strong></div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4 mb-3">
                                                    <div className="text-muted" style={{ fontSize: '12px' }}>Cidade</div>
                                                    <div><strong>{exibeValor(endereco.cidade)}</strong></div>
                                                </div>
                                                <div className="col-md-4 mb-3">
                                                    <div className="text-muted" style={{ fontSize: '12px' }}>Bairro</div>
                                                    <div><strong>{exibeValor(endereco.bairro)}</strong></div>
                                                </div>
                                                <div className="col-md-4 mb-3">
                                                    <div className="text-muted" style={{ fontSize: '12px' }}>Logradouro</div>
                                                    <div><strong>{exibeValor(endereco.logradouro)}</strong></div>
                                                </div>
                                            </div>
                                            <hr />
                                            <div className="row">
                                                <div className="col-md-3 mb-3">
                                                    <div className="text-muted" style={{ fontSize: '12px' }}>Número</div>
                                                    <div><strong>{exibeValor(endereco.numero)}</strong></div>
                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <div className="text-muted" style={{ fontSize: '12px' }}>Complemento</div>
                                                    <div><strong>{exibeValor(endereco.complemento)}</strong></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="row mt-3">
                            <div className="col-12">
                                <h5 className="mb-3">Pedidos</h5>
                                {isLoadingPedidos ? (
                                    <div className="row no-gutters">
                                        <div className="col-12 text-center py-5">
                                            <div className="spinner-border text-primary" role="status" />
                                        </div>
                                    </div>
                                ) : (
                                    <div className="card">
                                        <div className="card-body p-0">
                                            <ReactTable
                                                data={listaPedidos}
                                                columns={columnsPedidos}
                                                manual
                                                pages={totalPaginasPedidos}
                                                page={paginaPedidos}
                                                pageSize={limitePedidos}
                                                onPageChange={onPageChangePedidos}
                                                onPageSizeChange={onPageSizeChangePedidos}
                                                defaultPageSize={5}
                                                className="-striped -highlight"
                                                headerClassName="ebs-table-header"
                                                previousText='Anterior'
                                                nextText='Próximo'
                                                loadingText='Carregando...'
                                                noDataText='Nenhum pedido encontrado.'
                                                pageText='Página'
                                                ofText='de'
                                                rowsText='linhas'
                                                loading={isLoadingPedidos}
                                                getTdProps={(state, rowInfo, column) => {
                                                    return {
                                                        onClick: (e, handleOriginal) => {
                                                            if (rowInfo) {
                                                                if (column.Header === 'Beneficiários' || column.Header === 'Endereço') handleOriginal && handleOriginal();
                                                                else selecionaPedido(rowInfo.original.idPedido);
                                                            }
                                                        }
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="row mt-3">
                            <div className="col-12">
                                <h5 className="mb-3">Histórico</h5>
                                {isLoadingHistorico ? (
                                    <div className="row no-gutters">
                                        <div className="col-12 text-center py-5">
                                            <div className="spinner-border text-primary" role="status" />
                                        </div>
                                    </div>
                                ) : (
                                    <div className="card">
                                        <div className="card-body p-0">
                                            <ReactTable
                                                data={historicoAssinatura}
                                                columns={columnsHistorico}
                                                defaultPageSize={5}
                                                className="-striped -highlight"
                                                headerClassName="ebs-table-header"
                                                previousText='Anterior'
                                                nextText='Próximo'
                                                loadingText='Carregando...'
                                                noDataText='Nenhum histórico encontrado.'
                                                pageText='Página'
                                                ofText='de'
                                                rowsText='linhas'
                                                loading={isLoadingHistorico}
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </>
                )}
            </div>

            <Modal isOpen={modalEndereco} toggle={toggleModalEndereco} size="lg">
                <ModalHeader toggle={toggleModalEndereco}>{modoNovoEndereco ? 'Novo endereço' : 'Endereços'}</ModalHeader>
                <ModalBody>
                    {modoNovoEndereco ? (
                        <>
                            <div className="row">
                                <div className="col-12 col-md-6 py-2">
                                    <label>Nome <sup><small>(*)</small></sup></label>
                                    <input className="form-control" type="text" name="nome" autoComplete="off" value={enderecoForm.nome} onChange={onChangeEndereco} />
                                </div>
                                <div className="col-12 col-md-3 py-2">
                                    <label>CEP <sup><small>(*)</small></sup></label>
                                    <InputMask
                                        autoComplete="off"
                                        name="cep"
                                        type="tel"
                                        className="form-control"
                                        maskChar=""
                                        id="cep"
                                        mask="99999-999"
                                        placeholder="00000-000"
                                        value={enderecoForm.cep}
                                        onChange={onChangeEndereco}
                                    />
                                </div>
                                <div className="col-12 col-md-3 py-2 d-flex align-items-end">
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" id="semNumero" name="semNumero" checked={enderecoForm.semNumero} onChange={onChangeEndereco} />
                                        <label className="form-check-label" htmlFor="semNumero">Sem número</label>
                                    </div>
                                </div>
                                <div className="col-12 col-md-6 py-2">
                                    <label>Logradouro</label>
                                    <input className="form-control" type="text" value={enderecoForm.logradouro} readOnly />
                                </div>
                                <div className="col-12 col-md-3 py-2">
                                    <label>Bairro</label>
                                    <input className="form-control" type="text" value={enderecoForm.bairro} readOnly />
                                </div>
                                <div className="col-12 col-md-2 py-2">
                                    <label>Cidade</label>
                                    <input className="form-control" type="text" value={enderecoForm.cidade} readOnly />
                                </div>
                                <div className="col-12 col-md-1 py-2">
                                    <label>UF</label>
                                    <input className="form-control" type="text" value={enderecoForm.uf} readOnly />
                                </div>
                                <div className="col-12 col-md-3 py-2">
                                    <label>Número</label>
                                    <input className="form-control" type="text" name="numero" autoComplete="off" value={enderecoForm.semNumero ? '' : enderecoForm.numero} disabled={enderecoForm.semNumero} onChange={onChangeEndereco} />
                                </div>
                                <div className="col-12 col-md-9 py-2">
                                    <label>Complemento</label>
                                    <input className="form-control" type="text" name="complemento" autoComplete="off" value={enderecoForm.complemento} onChange={onChangeEndereco} />
                                </div>
                            </div>
                        </>
                    ) : (
                        <div className="row">
                            {loadingEndereco ? (
                                <div className="col-12 text-center py-3">
                                    <div className="spinner-border text-primary" role="status" />
                                </div>
                            ) : (
                                <>
                                    {listaEnderecos.length > 0 ? (
                                        listaEnderecos.map((item) => (
                                            <div className="col-12" key={item.idEndereco}>
                                                <div className={`border rounded p-3 mb-2 d-flex justify-content-between align-items-center ${novoEndereco === item.idEndereco ? 'border-info' : ''}`}>
                                                    <div>
                                                        <div className="d-flex align-items-center">
                                                            <strong>{item.nome}</strong>
                                                            {item.principal === 1 && (
                                                                <span className="badge badge-info ml-2">Principal</span>
                                                            )}
                                                        </div>
                                                        <div>{`${item.logradouro}, ${item.numero || 'S/N'} - ${item.cidade}/${item.uf}`}</div>
                                                    </div>
                                                    {novoEndereco === item.idEndereco ? (
                                                        <span className="badge badge-info">Selecionado</span>
                                                    ) :
                                                        <button
                                                            className="btn btn-outline-info btn-sm"
                                                            type="button"
                                                            onClick={() => setNovoEndereco(item.idEndereco)}
                                                            disabled={loadingSelecionarEndereco}
                                                        >
                                                            Selecionar
                                                        </button>
                                                    }
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="col-12 text-center py-2">
                                            <i>Nenhum endereço encontrado.</i>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    )}
                </ModalBody>
                <ModalFooter className='justify-content-between'>
                    {modoNovoEndereco ? (
                        <>
                            <button className='btn btn-secondary' onClick={() => setModoNovoEndereco(false)}>Voltar</button>
                            <button className='btn btn-success' onClick={() => salvarModalEndereco(true)}>Salvar Endereço</button>
                        </>
                    ) : (
                        <>
                            <button className="btn btn-outline-primary" type="button" onClick={abrirNovoEndereco}>
                                Novo endereço
                            </button>

                            <button className="btn btn-success" disabled={!novoEndereco} type="button" onClick={() => salvarModalEndereco(false)}>
                                Selecionar endereço
                            </button>
                        </>
                    )}
                </ModalFooter>
            </Modal>

            <Modal isOpen={modalEnderecoPedido} toggle={toggleModalEnderecoPedido} size="lg">
                <ModalHeader toggle={toggleModalEnderecoPedido}>Endereço do pedido</ModalHeader>
                <ModalBody>
                    {loadingEnderecoPedido ? (
                        <div className="row">
                            <div className="col-12 text-center py-3">
                                <div className="spinner-border text-primary" role="status" />
                            </div>
                        </div>
                    ) : (
                        <>
                            {exibeDestinatarioPedido && (
                                <div className="row">
                                    <div className="col-md-12 mb-3">
                                        <div className="text-muted" style={{ fontSize: '12px' }}>Nome destinatário</div>
                                        <div><strong>{exibeValor(enderecoPedido.nomeDestinatario)}</strong></div>
                                    </div>
                                </div>
                            )}
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <div className="text-muted" style={{ fontSize: '12px' }}>Nome</div>
                                    <div><strong>{exibeValor(enderecoPedido.titulo)}</strong></div>
                                </div>
                                <div className="col-md-3 mb-3">
                                    <div className="text-muted" style={{ fontSize: '12px' }}>CEP</div>
                                    <div><strong>{exibeValor(enderecoPedido.cep)}</strong></div>
                                </div>
                                <div className="col-md-3 mb-3">
                                    <div className="text-muted" style={{ fontSize: '12px' }}>UF</div>
                                    <div><strong>{exibeValor(enderecoPedido.uf)}</strong></div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4 mb-3">
                                    <div className="text-muted" style={{ fontSize: '12px' }}>Cidade</div>
                                    <div><strong>{exibeValor(enderecoPedido.cidade)}</strong></div>
                                </div>
                                <div className="col-md-4 mb-3">
                                    <div className="text-muted" style={{ fontSize: '12px' }}>Bairro</div>
                                    <div><strong>{exibeValor(enderecoPedido.bairro)}</strong></div>
                                </div>
                                <div className="col-md-4 mb-3">
                                    <div className="text-muted" style={{ fontSize: '12px' }}>Logradouro</div>
                                    <div><strong>{exibeValor(enderecoPedido.logradouro)}</strong></div>
                                </div>
                            </div>
                            <hr />
                            <div className="row">
                                <div className="col-md-3 mb-3">
                                    <div className="text-muted" style={{ fontSize: '12px' }}>Número</div>
                                    <div><strong>{exibeValor(enderecoPedido.numero)}</strong></div>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <div className="text-muted" style={{ fontSize: '12px' }}>Complemento</div>
                                    <div><strong>{exibeValor(enderecoPedido.complemento)}</strong></div>
                                </div>
                            </div>
                        </>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggleModalEnderecoPedido}>Fechar</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={modalStatus} toggle={toggleModalStatus}>
                <ModalHeader toggle={toggleModalStatus}>Alterar status de assinatura</ModalHeader>
                <ModalBody>
                    <div className="alert alert-warning">
                        Alterar o status da assinatura irá interferir diretamente no acesso do usuário à assinatura e também na renovação dos próximos pedidos.
                    </div>
                    <div className="row mb-5">
                        <div className="col-12 mb-5">
                            <Select
                                id="ddlStatusAssinatura"
                                placeholder="Selecione um status"
                                closeMenuOnSelect={true}
                                components={animatedComponents}
                                value={statusSelecionadoOption}
                                name="statusSelecionado"
                                onChange={handleStatusChange}
                                options={statusOptions.filter((status) => status.label !== dados.status).map((status) => ({ value: status.value, label: status.label }))}
                            />
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button className="btn btn-secondary" type="button" onClick={toggleModalStatus}>
                        Cancelar
                    </button>
                    <button
                        className="btn btn-success"
                        type="button"
                        onClick={alterarStatusAssinatura}
                        disabled={loadingSalvarStatus || statusSelecionado === null}
                    >
                        {loadingSalvarStatus ? 'Salvando...' : 'Salvar'}
                    </button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={modalTransportadora} toggle={toggleModalTransportadora}>
                <ModalHeader toggle={toggleModalTransportadora}>Editar transportadora</ModalHeader>
                <ModalBody>
                    <div className="alert alert-warning">
                        Alterar a transportadora da assinatura irá interferir diretamente no processo de entrega dos próximos pedidos.
                    </div>
                    <div className="row">
                        <div className="col-12 py-2 mb-5">
                            <Select
                                id="ddlTransportadora"
                                placeholder="Selecione uma transportadora"
                                closeMenuOnSelect={true}
                                components={animatedComponents}
                                value={transportadoraSelecionadaOption}
                                name="transportadoraSelecionada"
                                onChange={handleTransportadoraChange}
                                options={transportadoraOptions}
                            />
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggleModalTransportadora}>Cancelar</Button>
                    <Button color="primary" onClick={salvarModalTransportadora} disabled={loadingSalvarTransportadora || transportadoraSelecionada === null}>
                        {loadingSalvarTransportadora ? 'Salvando...' : 'Salvar'}
                    </Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={modalPagamento} toggle={toggleModalPagamento}>
                <ModalHeader toggle={toggleModalPagamento}>Editar método de pagamento</ModalHeader>
                <ModalBody>
                    <div className="alert alert-warning">
                        Alterar o método de pagamento irá interferir diretamente na cobrança do pedido seguinte. Caso o método de pagamento seja alterado para um método offline (ex: boleto ou pix), será necessário gerar um novo código de pagamento para que o próximo pedido seja cobrado corretamente.
                    </div>
                    <div className="row">
                        <div className="col-12 py-2 mb-5">
                            <Select
                                id="ddlFormaPagamento"
                                placeholder="Selecione uma forma de pagamento"
                                closeMenuOnSelect={true}
                                components={animatedComponents}
                                value={pagamentoSelecionadoOption}
                                name="pagamentoSelecionado"
                                onChange={handlePagamentoChange}
                                options={pagamentoOptions}
                            />
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggleModalPagamento}>Cancelar</Button>
                    <Button color="primary" onClick={salvarModalPagamento} disabled={loadingSalvarPagamento || pagamentoSelecionado === null}>
                        {loadingSalvarPagamento ? 'Salvando...' : 'Salvar'}
                    </Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={modalDestinatario} toggle={toggleModalDestinatario}>
                <ModalHeader toggle={toggleModalDestinatario}>Editar nome do destinatário</ModalHeader>
                <ModalBody>
                    <div className="alert alert-warning">
                        O nome do destinatário só deve ser preenchido caso o destinatário seja diferente do solicitante.
                    </div>
                    <div className="row">
                        <div className="col-12 py-2">
                            <label>Nome do destinatário</label>
                            <input
                                className="form-control"
                                type="text"
                                name="nomeDestinatario"
                                autoComplete="off"
                                value={nomeDestinatario}
                                onChange={(e) => setNomeDestinatario(e.target.value)}
                            />
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggleModalDestinatario}>Cancelar</Button>
                    <Button color="primary" onClick={salvarModalDestinatario} disabled={loadingSalvarDestinatario}>
                        {loadingSalvarDestinatario ? 'Salvando...' : 'Salvar'}
                    </Button>
                </ModalFooter>
            </Modal>

            <Modal size='lg' isOpen={modalOrganizacao} toggle={toggleModalOrganizacao}>
                <ModalHeader toggle={toggleModalOrganizacao}>Organização</ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className="col-md-4 mb-3">
                            <div className="text-muted" style={{ fontSize: '12px' }}>Coord. Geral</div>
                            <div><strong>{exibeValor(organizacao.coordGeral)}</strong></div>
                        </div>
                        <div className="col-md-4 mb-3">
                            <div className="text-muted" style={{ fontSize: '12px' }}>Coordenadoria</div>
                            <div><strong>{exibeValor(organizacao.coordenadoria)}</strong></div>
                        </div>
                        <div className="col-md-4 mb-3">
                            <div className="text-muted" style={{ fontSize: '12px' }}>Sub</div>
                            <div><strong>{exibeValor(organizacao.sub)}</strong></div>
                        </div>
                        <div className="col-md-4 mb-3">
                            <div className="text-muted" style={{ fontSize: '12px' }}>RM</div>
                            <div><strong>{exibeValor(organizacao.rm)}</strong></div>
                        </div>
                        <div className="col-md-4 mb-3">
                            <div className="text-muted" style={{ fontSize: '12px' }}>Regional</div>
                            <div><strong>{exibeValor(organizacao.regional)}</strong></div>
                        </div>
                        <div className="col-md-4 mb-3">
                            <div className="text-muted" style={{ fontSize: '12px' }}>Distrito</div>
                            <div><strong>{exibeValor(organizacao.distrito)}</strong></div>
                        </div>
                        <div className="col-md-6 mb-3">
                            <div className="text-muted" style={{ fontSize: '12px' }}>Comunidade</div>
                            <div><strong>{exibeValor(organizacao.comunidade)}</strong></div>
                        </div>
                        <div className="col-md-6 mb-3">
                            <div className="text-muted" style={{ fontSize: '12px' }}>Bloco</div>
                            <div><strong>{exibeValor(organizacao.bloco)}</strong></div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggleModalOrganizacao}>Fechar</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={modalPixBoleto} toggle={toggleModalPixBoleto}>
                <ModalHeader toggle={toggleModalPixBoleto}>Pagamento</ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className="col-12 mb-2">
                            <div>Utilize o código abaixo para pagamento</div>
                        </div>
                        <div className="col-12">
                            <textarea className="form-control" rows="5" readOnly value={codigoPagamento} />
                        </div>
                        <div className="col-12 text-right mt-2">
                            <button className="btn btn-primary btn-sm" type="button" onClick={() => handleCopy(codigoPagamento)}>
                                {copiado ? (
                                    <>✓ Copiado</>
                                ) : (
                                    'Copiar'
                                )}
                            </button>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggleModalPixBoleto}>Fechar</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={modalSuccess} toggle={toggleModalSuccess}>
                <ModalHeader toggle={toggleModalSuccess}>Sucesso</ModalHeader>
                <ModalBody>
                    {successMessage}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggleModalSuccess}>Fechar</Button>
                </ModalFooter>
            </Modal>

            <ModalBeneficiariosCile
                isOpen={modalBeneficiariosCile}
                toggle={toggleModalBeneficiariosCile}
                listaBeneficiariosCile={listaBeneficiariosCile}
                infos={infosPedido}
                email={orderDetails ? orderDetails.emailSolicitante : ""}
            />

            <ErrorModal
                isOpen={hasError}
                message={errorMessage}
                closeErrorModal={closeErrorModal}
            />
        </div>
    );
};

export default SubscriptionCileDetails;
